import { createSelector } from '@ngrx/store';
import { getBrandPLPState } from '../feature.selector';
import { BrandPLPPageState } from '../state';

export const getBrandInfoContent = createSelector(
  getBrandPLPState,
  (state: BrandPLPPageState) => state && state.brandInfo
);

export const getSecondLevelCategoriesBrand = createSelector(
  getBrandPLPState,
  (state: BrandPLPPageState) => state.brandInfo.categories.reduce((acc, {children}) => acc.concat(children), [])
)

